import ENV from "../config/config";

const URL_PREFIX = ENV === "main" ? "" : ENV + ".";

const env = ENV === "dev" ? "" : URL_PREFIX;

const URL =
  ENV === "dev"
    ? "https://dev.backend-icici-logs.metawing.ai/"
    : "https://" + env + "backend-icici-logs.metawing.ai/";

const BASE_URL = {
  icici_logs: {
    url: URL,
    version: "v1/icici-logs/",
  },
};

export default BASE_URL;
